<template>
  <div class="main-wrap" id='detail-movie'>
    <div class="bg-movie">
      <slot name="bgimage">
      </slot>
      <img src="https://i.ytimg.com/vi/_nE8AhurAs0/mqdefault.jpg" alt="poster">
    </div>
    <div class="container-general">
      <v-row align="center" justify="center">
        <v-col lg="4" sm="12" cols="12">
          <slot name="video"/>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col lg="10" md="12" class="pa-6">
          <v-card  class="about">
            <v-row>
              <v-col class="px-4" md="7" cols="12">
                <h4 class="use-text-title2 mb-3">
                  <slot name="title"/>
                </h4>
                <p><slot name="description"/></p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div id="footer">
      <footer-main invert />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '../assets/styles';

.container-wrap {
  margin-top: -40px;

  > section {
    position: relative;
  }
}

h4 {
  line-height: 110%;
  margin: 1.52rem 0 0.912rem 0;
}

.container-general {
  position: relative;
  margin-top: 90px;
  padding-top: 32px;
  padding-bottom: 32px;

  @include breakpoints-up(md) {
    padding-left: 32px;
    padding-right: 32px;
  }
}

#detail-movie {
  .container-wrap {
    padding: spacing(15, 0);
    @inlcude breakpoints-down(sm) {
      margin: spacing(10, 0);
    }
  }

  .desc {
    max-height: 130px;
    padding: spacing(1, 0);
    margin-bottom: $spacing5;
    h6 {
      font-weight: $font-medium;
    }
  }

  .text {
    @include text-align(left);
    height: 450px;
    h4 {
      font-weight: $font-bold;
      margin-bottom: $spacing2;
      width: 100%;
      span {
        display: block;
        font-weight: $font-medium;
      }
    }
  }

  .property {
    width: 100%;
    display: flex;
    margin-bottom: $spacing2;
    .star {
      color: #ff9500;
      @include margin-right($spacing2);

      i {
        color: #ff9500;
      }
    }
    .divider {
      background: none;
      border-left: 1px solid;
      @include use-theme(border-color, $light-text-primary, $dark-text-primary);
      height: 12px;
      margin: 6px $spacing2;
      display: inline-block;
    }
  }

  .btn-area {
    z-index: 10;
    position: relative;
    display: flex;
    width: 100%;
    align-items: center;
    @include breakpoints-down(xs) {
      display: block;
      & > * {
        margin: spacing(0, 0, 2);
      }
    }
    .text-btn {
      padding-left: 8px;
      padding-right: 8px;
      @include use-theme(color, $palette-secondary-main, $palette-secondary-light);
      i {
        font-size: 1.3rem;
        @include margin-right(4px)
      }
    }
    & > * {
      @include margin-right($spacing2)
    }
  }

  .image {
    text-align: center;
    line-height: 360px;
    vertical-align: middle;
    position: relative !important;
    width: 250px;
    height: 360px;
    margin: 0 auto;
    i {
      position: absolute;
      font-size: 52px;
      top: calc(50% - 30px);
      left: calc(50% - 30px);
      border: 5px solid $palette-common-white;
      z-index: 10;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      line-height: 54px;
      padding-left: 4px;
      color: $palette-common-white;
      background: rgba(0, 0, 0, 0.4)
    }
    figure {
      @include shadow3;
      width: 250px;
      height: 360px;
      overflow: hidden;
      border-radius: $rounded-big;
      margin: 0 auto;
      img {
        width: 100%;
      }
    }
  }

  .bg-movie {
    direction: ltr;
    width: 200%;
    height: 720px;
    margin-left: -50%;
    border-radius: 0 0 50% 50%;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    img {
      width: 50%;
      top: -50%;
      position: relative;
      margin: 0 auto;
      //opacity: 0.2;
      filter: blur(10px);
      .v-application--is-rtl & {
        left: -25%;
      }
      .v-application--is-ltr & {
        left: 25%;
      }
    }
  }

  .about {
    /*margin-top: $spacing12 * -1;*/
    margin-top: -75;
    padding: spacing(7, 10);
    @include breakpoints-down(xs) {
      padding: $spacing2
    }
    h4 {
      margin: 0;
    }
    .btn-area {
      margin-top: $spacing6;
    }
    .person {
      @include breakpoints-down(sm) {
        margin-top: $spacing5;
      }
      h6 {
        font-size: 14px;
        text-transform: uppercase;
        font-weight: $font-bold;
      }
      p {
        margin-bottom: $spacing4;
      }
    }
  }
}
</style>

<script>
import imgAPI from '../static/images/imgAPI'
import brand from '../static/text/brand'
import Header from '../components/Header'
//import Footer from '../components/Footer/Footer'

export default {
  components: {
    'header-main': Header,
    //'footer-main': Footer
  },
  data: () => ({
    imgAPI: imgAPI
  }),
  computed: {
    isMobile() {
      const xsDown = ['xsDown'];
      return xsDown.indexOf(this.$mq) > -1
    }
  },
  head() {
    return {
      title: brand.movie.name + ' - Detail Movie'
    }
  }
}
</script>
